// ============================================================
// FONTE ÚNICA DE VERDADE — Profissões da Plataforma
// Importe daqui em qualquer feature que precise referenciar
// profissões: simulador, mapa do mercado, trilhas, etc.
// ============================================================

export const PROFESSION_CATEGORIES = [
  "Conteúdo & Escrita",
  "Design & Vídeo",
  "Marketing Digital",
  "Vendas",
  "Operações & Dados",
  "Comunidade & Atendimento",
  "Tecnologia",
];

// level: "leadership" | "tactical" | "operational"
//   leadership   — lidera times, define estratégia, tomada de decisão
//   tactical     — execução especializada com autonomia e visão de negócio
//   operational  — execução estruturada, processos, rotina

export const PROFESSIONS = [
  // ── Conteúdo & Escrita ─────────────────────────────────
  {
    id: "copywriter",
    name: "Copywriter",
    category: "Conteúdo & Escrita",
    level: "tactical",
    description: "Cria textos persuasivos focados em conversão: anúncios, landing pages, e-mails e scripts de venda.",
    keywords: ["escrita", "persuasão", "conversão", "anúncio", "copy"],
  },
  {
    id: "redator",
    name: "Redator",
    category: "Conteúdo & Escrita",
    level: "operational",
    description: "Produz conteúdo editorial, artigos, roteiros e materiais de blog com foco em informação e engajamento.",
    keywords: ["escrita", "blog", "conteúdo", "editorial", "roteiro"],
  },
  {
    id: "estrategista-conteudo",
    name: "Estrategista de Conteúdo",
    category: "Conteúdo & Escrita",
    level: "leadership",
    description: "Planeja e estrutura a estratégia de conteúdo de uma marca, definindo pautas, formatos e canais.",
    keywords: ["estratégia", "conteúdo", "planejamento", "pauta", "editorial"],
  },
  {
    id: "social-media",
    name: "Social Media",
    category: "Conteúdo & Escrita",
    level: "tactical",
    description: "Gerencia redes sociais, cria calendários editoriais e produz conteúdo para engajamento de audiência.",
    keywords: ["redes sociais", "instagram", "tiktok", "engajamento", "conteúdo"],
  },

  // ── Design & Vídeo ─────────────────────────────────────
  {
    id: "designer",
    name: "Designer",
    category: "Design & Vídeo",
    level: "tactical",
    description: "Cria peças gráficas, identidades visuais e materiais de comunicação para marcas e campanhas.",
    keywords: ["design", "gráfico", "identidade visual", "criação", "branding"],
  },
  {
    id: "web-designer",
    name: "Web Designer",
    category: "Design & Vídeo",
    level: "tactical",
    description: "Projeta interfaces e layouts de sites e landing pages com foco em experiência visual e usabilidade.",
    keywords: ["web", "interface", "ui", "landing page", "figma"],
  },
  {
    id: "videomaker",
    name: "Videomaker",
    category: "Design & Vídeo",
    level: "tactical",
    description: "Produz vídeos do início ao fim — roteiro, gravação e edição — para marcas, redes sociais e cursos.",
    keywords: ["vídeo", "produção", "gravação", "youtube", "edição"],
  },
  {
    id: "editor-videos",
    name: "Editor de Vídeos",
    category: "Design & Vídeo",
    level: "operational",
    description: "Edita e finaliza vídeos gravados, adicionando cortes, trilha, motion e legendas.",
    keywords: ["edição", "vídeo", "premiere", "after effects", "motion"],
  },

  // ── Marketing Digital ──────────────────────────────────
  {
    id: "analista-marketing",
    name: "Analista de Marketing",
    category: "Marketing Digital",
    level: "operational",
    description: "Analisa dados de campanhas, acompanha métricas e gera insights para otimizar ações de marketing.",
    keywords: ["análise", "métricas", "dados", "campanhas", "marketing"],
  },
  {
    id: "analista-email-marketing",
    name: "Analista de E-mail Marketing",
    category: "Marketing Digital",
    level: "operational",
    description: "Cria, segmenta e dispara campanhas de e-mail, acompanhando taxas de abertura e conversão.",
    keywords: ["e-mail", "automação", "segmentação", "klav", "disparos"],
  },
  {
    id: "gestor-trafego",
    name: "Gestor de Tráfego",
    category: "Marketing Digital",
    level: "tactical",
    description: "Gerencia anúncios pagos no Meta, Google e TikTok para gerar leads e vendas com eficiência.",
    keywords: ["tráfego pago", "meta ads", "google ads", "cpa", "roas"],
  },
  {
    id: "gestor-marketing",
    name: "Gestor de Marketing",
    category: "Marketing Digital",
    level: "leadership",
    description: "Lidera o time e a estratégia de marketing de uma empresa, integrando canais e definindo metas.",
    keywords: ["gestão", "liderança", "estratégia", "time", "marketing"],
  },
  {
    id: "estrategista-digital",
    name: "Estrategista Digital",
    category: "Marketing Digital",
    level: "leadership",
    description: "Define a visão e o posicionamento digital de marcas, conectando canais, produto e audiência.",
    keywords: ["estratégia", "digital", "posicionamento", "funil", "go-to-market"],
  },
  {
    id: "analista-infra-mkt",
    name: "Analista de Infraestrutura de Marketing Digital",
    category: "Marketing Digital",
    level: "operational",
    description: "Configura e mantém a stack de ferramentas de marketing: CRM, automações, tracking e integrações.",
    keywords: ["infra", "automação", "crm", "tracking", "make", "zapier"],
  },

  // ── Vendas ─────────────────────────────────────────────
  {
    id: "gestor-comercial",
    name: "Gestor Comercial",
    category: "Vendas",
    level: "leadership",
    description: "Lidera equipes de vendas, define metas, processos e estratégias para crescimento de receita.",
    keywords: ["vendas", "gestão", "metas", "receita", "liderança"],
  },
  {
    id: "closer",
    name: "Closer",
    category: "Vendas",
    level: "tactical",
    description: "Especialista em fechar negociações de alto ticket, conduzindo reuniões e contornando objeções.",
    keywords: ["fechamento", "high ticket", "consultivo", "negociação", "inside sales"],
  },
  {
    id: "sdr",
    name: "SDR",
    category: "Vendas",
    level: "operational",
    description: "Prospecta e qualifica leads inbound, agendando reuniões para o time de closers.",
    keywords: ["prospecção", "qualificação", "inbound", "leads", "pipeline"],
  },
  {
    id: "bdr",
    name: "BDR",
    category: "Vendas",
    level: "operational",
    description: "Desenvolve novos negócios via prospecção ativa e outbound, abrindo portas para novas contas.",
    keywords: ["prospecção", "outbound", "cold", "desenvolvimento", "b2b"],
  },
  {
    id: "vendedor-whatsapp",
    name: "Vendedor de WhatsApp",
    category: "Vendas",
    level: "operational",
    description: "Converte leads e responde clientes via WhatsApp com agilidade, usando scripts e follow-up.",
    keywords: ["whatsapp", "follow-up", "script", "conversão", "atendimento"],
  },
  {
    id: "social-seller",
    name: "Social Seller",
    category: "Vendas",
    level: "tactical",
    description: "Usa redes sociais para atrair, engajar e converter clientes de forma orgânica e consultiva.",
    keywords: ["social selling", "linkedin", "instagram", "orgânico", "consultivo"],
  },

  // ── Operações & Dados ──────────────────────────────────
  {
    id: "sales-ops",
    name: "Sales Ops",
    category: "Operações & Dados",
    level: "tactical",
    description: "Estrutura processos, ferramentas e dados do funil de vendas para aumentar eficiência comercial.",
    keywords: ["operações", "processos", "funil", "dados", "crm"],
  },
  {
    id: "analista-crm",
    name: "Analista de CRM",
    category: "Operações & Dados",
    level: "operational",
    description: "Configura e opera sistemas de CRM, segmenta bases e cria fluxos de nutrição e retenção.",
    keywords: ["crm", "hubspot", "pipedrive", "automação", "retenção"],
  },
  {
    id: "gestor-produto-digital",
    name: "Gestor de Produto Digital",
    category: "Operações & Dados",
    level: "leadership",
    description: "Define a visão, o roadmap e as prioridades de um produto digital, conectando negócio e tecnologia.",
    keywords: ["produto", "roadmap", "ux", "kpis", "discovery"],
  },
  {
    id: "gestor-operacoes-digitais",
    name: "Gestor de Operações Digitais",
    category: "Operações & Dados",
    level: "leadership",
    description: "Garante que as operações digitais de uma empresa rodem de forma eficiente, escalável e integrada.",
    keywords: ["operações", "processos", "escalabilidade", "automação", "gestão"],
  },
  {
    id: "gerente-projetos-digitais",
    name: "Gerente de Projetos Digitais",
    category: "Operações & Dados",
    level: "leadership",
    description: "Planeja e coordena projetos digitais, gerenciando prazos, entregas e equipes multidisciplinares.",
    keywords: ["projetos", "prazos", "scrum", "agile", "coordenação"],
  },

  // ── Comunidade & Atendimento ───────────────────────────
  {
    id: "gestor-comunidade",
    name: "Gestor de Comunidade",
    category: "Comunidade & Atendimento",
    level: "tactical",
    description: "Cria e nutre comunidades online, engajando membros e gerando sentimento de pertencimento.",
    keywords: ["comunidade", "engajamento", "discord", "grupo", "membros"],
  },
  {
    id: "gestor-atendimento-digital",
    name: "Gestor de Atendimento Digital",
    category: "Comunidade & Atendimento",
    level: "leadership",
    description: "Lidera o time de suporte e atendimento digital, garantindo qualidade e eficiência nas interações.",
    keywords: ["atendimento", "suporte", "satisfação", "helpdesk", "qualidade"],
  },
  {
    id: "analista-customer-success",
    name: "Analista de Customer Success",
    category: "Comunidade & Atendimento",
    level: "tactical",
    description: "Acompanha clientes após a compra para garantir sucesso, retenção e expansão de conta.",
    keywords: ["cs", "retenção", "churn", "sucesso do cliente", "onboarding"],
  },
  {
    id: "analista-customer-experience",
    name: "Analista de Customer Experience",
    category: "Comunidade & Atendimento",
    level: "tactical",
    description: "Mapeia e melhora a jornada do cliente em todos os pontos de contato com a marca.",
    keywords: ["cx", "jornada", "nps", "experiência", "satisfação"],
  },
  {
    id: "suporte-alunos",
    name: "Suporte a Alunos e Usuários",
    category: "Comunidade & Atendimento",
    level: "operational",
    description: "Auxilia alunos ou usuários em dúvidas, problemas técnicos e uso de plataformas digitais.",
    keywords: ["suporte", "alunos", "helpdesk", "faq", "plataforma"],
  },

  // ── Tecnologia ─────────────────────────────────────────
  {
    id: "desenvolvedor-vibe-coder",
    name: "Desenvolvedor Vibe Coder",
    category: "Tecnologia",
    level: "tactical",
    description: "Desenvolve produtos digitais usando IA e ferramentas no-code/low-code com velocidade e criatividade.",
    keywords: ["desenvolvimento", "ia", "no-code", "vibe coding", "produto"],
  },
];

// ── Utilitários ────────────────────────────────────────────

/** Lista de nomes para dropdowns e compatibilidade com o algoritmo vocacional */
export const PROFESSION_NAMES = PROFESSIONS.map(p => p.name);

/** Busca por nome exato */
export const getProfessionByName = (name) =>
  PROFESSIONS.find(p => p.name === name);

/** Busca por id */
export const getProfessionById = (id) =>
  PROFESSIONS.find(p => p.id === id);

/** Filtra por categoria */
export const getProfessionsByCategory = (category) =>
  PROFESSIONS.filter(p => p.category === category);

/** Filtra por nível */
export const getProfessionsByLevel = (level) =>
  PROFESSIONS.filter(p => p.level === level);

/** Busca textual por nome, descrição ou keywords */
export const searchProfessions = (query) => {
  const q = query.toLowerCase();
  return PROFESSIONS.filter(p =>
    p.name.toLowerCase().includes(q) ||
    p.description.toLowerCase().includes(q) ||
    p.keywords.some(k => k.toLowerCase().includes(q))
  );
};
